/* eslint-disable no-invalid-this */
import ApiService, { USERS_API_CONTEXT, USERS_API_HOST, ONBOARDING_HOST, getApiKey } from './ApiService';
import { removeAuthData } from './auth.service';
/**
 * @override
 */
class UsersService extends ApiService {
  /**
   * constructor
   */
  constructor() {
    super({ baseURL: USERS_API_HOST });
  }

  /**
   * Get current user info
   * @param {Object} config Axios config
   * @return {Object} Response with list of users
   */
  getMe = async config => {
    try {
      const response = await this.get(`${USERS_API_CONTEXT}/me`, config);

      if (response.data.group && response.data.group.uuid === '9c0a2e16-5261-4ba6-89a1-899774c6ac46') {
        await removeAuthData();
        return Promise.reject({});
      }
      localStorage.setItem('BOCOUS', btoa(unescape(encodeURIComponent(JSON.stringify(response.data)))));

      return response;
    } catch (error) {
      console.error('Error fetching user data:', error);
      throw error;
    }
  };

  /**
   * Get user section views
   * @param {String} userid UUID user
   * @param {String} section Name of the section
   * @return {Object} Response with list of views
   */
  getSectionViews = (userid, section) =>
    this.get(`${USERS_API_CONTEXT}/users/${userid}/sections-views/${section.toUpperCase()}`);
  /**
   * Create section view
   * @param {String} userid UUID user
   * @param {String} section Name of the section
   * @param {Object} view View to persist
   * @return {Object} Response with persisted view
   */
  createSectionView = (userid, section, view) =>
    this.post(`${USERS_API_CONTEXT}/users/${userid}/sections-views/${section.toUpperCase()}`, view);
  /**
   * detele section view
   * @param {String} userid UUID user
   * @param {String} uuidView UUID view
   * @return {Object} Response with persisted view
   */
  removeView = (userid, uuidView) => this.delete(`${USERS_API_CONTEXT}/users/${userid}/sections-views/${uuidView}`);
  /**
   * Update section view
   * @param {String} userid Id of the view to update
   * @param {String} uuidView View data
   * @param {Object} view View to change
   * @return {Object} Response with updated view
   */
  updateSectionView = (userid, uuidView, view) =>
    this.patch(`${USERS_API_CONTEXT}/users/${userid}/sections-views/${uuidView}`, view);
  /**
   * Delete section view
   * @param {String} id Id of the view to delete
   * @return {Object} Response with updated view
   */
  deleteSectionView = id => this.delete(`${USERS_API_CONTEXT}/sections-views/${id}`);
  /**
   * Get users list
   * @param {Object} sort Sort
   * @param {Object} config Axios config
   * @return {Object} Response with users
   */
  getUsers = (sort, config) => {
    if (sort.trim() !== '') {
      return this.getList(`${USERS_API_CONTEXT}/users?$orderby=${sort}`, config);
    } else {
      return this.getList(`${USERS_API_CONTEXT}/users`, config);
    }
  };
  /**
   * Get user
   * @param {String} uuid User UUID
   * @param {Object} config Axios config
   * @return {Object} Response with user
   */
  getUsersByUUIId = (uuid, config) => this.get(`${USERS_API_CONTEXT}/users/${uuid}`, config);

  /**
   * Buscar usuarios
   * @param {Array} search Búsqueda
   * @param {Object} config Axios config
   * @param {Object} sort Sort
   * @return {Object} Response with users
   */
  getSearch = (search, config, sort = false) => {
    const sortQueryParam = sort ? `&$orderby=${sort}` : '';
    return this.getList(`${USERS_API_CONTEXT}/users?$search=${search}${sortQueryParam}`, config);
  };
  /**
   * @param {String} url Url
   * @param {Object} config Axios config
   * @return {Object} Response with list of users
   */
  getUsersPagination = (url, config) => this.get(`${url}`, config);
  /**
   * Actualizamos la información del usuario
   * @param {Object} user User data
   * @return {Object} Response of put operation
   */
  update = user => {
    user.uuid_group = undefined;
    user.uuid_permission_set = undefined;
    user._links._self = undefined;
    user.permission_set = undefined;
    user.group = undefined;
    return this.put(`${USERS_API_CONTEXT}/users/${user.uuid}`, user);
  };

  create = user => {
    user.uuid_group = undefined;
    user.uuid_permission_set = undefined;
    user.permission_set = undefined;
    user.group = undefined;
    return this.post(`${USERS_API_CONTEXT}/users`, user);
  };
  /**
   * Delete user
   * @param {String} uuid User id
   * @return {Object} Response of delete operation
   */
  deleteByUUIId = uuid => {
    return this.delete(`${USERS_API_CONTEXT}/users/${uuid}`, {});
  };
  /**
   * Change group
   * @param {String} uuid UUID of user
   * @param {String} group Uri of group
   * @return {Object} Response of patch operation
   */
  changeGroup = (uuid, group) => {
    const payload = {
      _links: {
        group,
        permission_set: null
      }
    };
    return this.patch(`${USERS_API_CONTEXT}/users/${uuid}`, payload);
  };
  changeDistributor = (uuid, distributor, subdistributor) => {
    const payload = {
      _links: {
        distributor,
        subdistributor
      }
    };
    return this.patch(`${USERS_API_CONTEXT}/users/${uuid}`, payload);
  };
  /**
   * Change user permission_set
   * @param {String} uuid UUID of user
   * @param {String} permission_set Uri of permission_set
   * @return {Object} Response of patch operation
   */
  changePermissionSet = (uuid, permission_set) => {
    const payload = {
      _links: {
        permission_set
      }
    };
    return this.patch(`${USERS_API_CONTEXT}/users/${uuid}`, payload);
  };

  /**
   * @override
   */
  download = (sort, config, headers) => {
    if (sort.trim() !== '') {
      return this.getDownload(`${USERS_API_CONTEXT}/users/download?$orderby=${sort}`, config, { headers });
    } else {
      return this.getDownload(`${USERS_API_CONTEXT}/users/download`, config, { headers });
    }
  };

  /**
   * get DB config vars
   * @param {Object} config Axios config
   * @return {Object} list of config vars
   */
  getConfigVars = config => {
    return this.getList(`${USERS_API_CONTEXT}/config`, config);
  };

  /**
   * get DB config vars By Key_name
   * @param {String} key var key_name
   * @param {Object} config Axios config
   * @return {Object} config var
   */
  getConfigVarByKey = (key, config) => {
    return this.get(`${USERS_API_CONTEXT}/config/${key}`, config);
  };

  /**
   * Return list of countries
   * @return {Object} list of country
   * @memberof UsersService
   */
  getCountries = () => {
    return this.get(`${USERS_API_CONTEXT}/onboarding/countries-info`);
  };

  /**
   * Return states of specified country
   * @param {Object} key_country Axios config
   * @return {Object} list of regions
   * @memberof UsersService
   */
  getCountryStates = key_country => {
    return this.get(`${USERS_API_CONTEXT}/onboarding/provinces/${key_country}`);
  };

  requestPasswordUpdate = payload => {
    const config = {
      headers: {
        apikey: getApiKey(window.location.href)
      }
    };
    return this.post(`${ONBOARDING_HOST}/users/password-recover`, payload, config);
  };

  passwordChange = payload => {
    const config = {
      headers: {
        apikey: getApiKey(window.location.href)
      }
    };
    return this.post(`${ONBOARDING_HOST}/users/password-change`, payload, config);
  };
  getPublicConfiguration = (uuidClientEntity = '') => {
    const config = {
      headers: {
        apikey: getApiKey(window.location.href)
      }
    };
    return this.get(`${USERS_API_CONTEXT}/onboarding/public-configuration/${uuidClientEntity}`, config);
  };
}

const userService = new UsersService();

export default userService;
